import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormHint', null, { withChildren: true });
